import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage/HomePage';
import ProjectDetails from './pages/ProjectDetails/ProjectDetails';
import ContactInformation from './pages/ContactInformation/ContactInformation';
import { LanguageProvider } from './context/LanguageContext';

const App = () => {
  return (
    <Router>
      <div className="App roboto-font">
        <Routes>
          <Route path="/" element={<Navigate to="/en" replace />} />
          <Route path="/:lang" element={<LanguageProvider><HomePage /></LanguageProvider>} />
          <Route path="/:lang/projects/:slug" element={<LanguageProvider><ProjectDetails /></LanguageProvider>} />
          <Route path="/:lang/contact" element={<LanguageProvider><ContactInformation /></LanguageProvider>} />
          <Route path="*" element={<Navigate to="/en" replace />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
